var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 20,
    viewBox: "0 0 50 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9437 16.1717H17.7329L19.7396 3.83938H22.9507L20.9437 16.1717ZM15.0318 3.83938L11.9709 12.3217L11.6086 10.4951L11.609 10.4958L10.5286 4.94977C10.5286 4.94977 10.398 3.83938 9.00554 3.83938H3.94512L3.88574 4.0482C3.88574 4.0482 5.43323 4.37016 7.24429 5.45779L10.0338 16.1721H13.3791L18.4874 3.83938H15.0318ZM40.2861 16.1717H43.2343L40.6638 3.83905H38.0828C36.8909 3.83905 36.6006 4.75811 36.6006 4.75811L31.812 16.1717H35.159L35.8284 14.3399H39.91L40.2861 16.1717ZM36.753 11.8094L38.4401 7.1943L39.3891 11.8094H36.753ZM32.0631 6.80503L32.5213 4.15673C32.5213 4.15673 31.1074 3.61902 29.6335 3.61902C28.0401 3.61902 24.2564 4.3154 24.2564 7.70166C24.2564 10.8877 28.6973 10.9273 28.6973 12.6008C28.6973 14.2743 24.7139 13.9744 23.3993 12.9191L22.922 15.6881C22.922 15.6881 24.3557 16.3845 26.5461 16.3845C28.7372 16.3845 32.0426 15.2501 32.0426 12.1623C32.0426 8.95587 27.5618 8.65733 27.5618 7.26324C27.5621 5.86882 30.6891 6.04795 32.0631 6.80503Z",
    fill: "#2566AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.609 10.4967L10.5286 4.95066C10.5286 4.95066 10.398 3.84027 9.00554 3.84027H3.94512L3.88574 4.04909C3.88574 4.04909 6.31797 4.55315 8.65091 6.44173C10.8816 8.24686 11.609 10.4967 11.609 10.4967Z",
    fill: "#E6A540"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVisa);
export default __webpack_public_path__ + "static/media/logo-visa.e306db2efa2849e072eecc390405744b.svg";
export { ForwardRef as ReactComponent };